import React from 'react'
import { Modal, LoadingOverlay, Stack, Card, Grid, Text, Table, Flex, Button } from '@mantine/core'

const ModalDetailRate = ({
    opened,
    onClose,
    loading,
    rateInfo,
    rateList
}) => {
    return (
        <Modal
            opened={opened}
            onClose={onClose}
            title={<Text fw={700} size="lg">Rate Details</Text>}
            size="lg"
        >
            <LoadingOverlay visible={loading} />
            {rateInfo && (
                <Stack gap="md">
                    {/* Header Info */}
                    <Card withBorder p="md" radius="md" bg="gray.0">
                        <Grid>
                            <Grid.Col span={6}>
                                <Text size="sm" c="dimmed">Name</Text>
                                <Text fw={500}>{rateInfo.name}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="sm" c="dimmed">Courier</Text>
                                <Text fw={500}>{rateInfo.courier}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="sm" c="dimmed">Origin</Text>
                                <Text fw={500}>{rateInfo.origin}</Text>
                            </Grid.Col>
                            <Grid.Col span={6}>
                                <Text size="sm" c="dimmed">Destination</Text>
                                <Text fw={500}>{rateInfo.destination}</Text>
                            </Grid.Col>
                        </Grid>
                    </Card>

                    {/* Rate Info */}
                    <Card withBorder p="md" radius="md">
                        <Grid>
                            <Grid.Col span={3}>
                                <Text size="sm" c="dimmed">Calculation</Text>
                                <Text fw={500}>{rateInfo.calculation}</Text>
                            </Grid.Col>
                            <Grid.Col span={3}>
                                <Text size="sm" c="dimmed">Minimum</Text>
                                <Text fw={500}>{rateInfo.minimum}</Text>
                            </Grid.Col>
                            <Grid.Col span={3}>
                                <Text size="sm" c="dimmed">Maximum</Text>
                                <Text fw={500}>{rateInfo.maximum}</Text>
                            </Grid.Col>
                            <Grid.Col span={3}>
                                <Text size="sm" c="dimmed">Remarks</Text>
                                <Text fw={500}>{rateInfo.remarks}</Text>
                            </Grid.Col>
                        </Grid>
                    </Card>

                    {/* Weight/Rate Table */}
                    <Card withBorder p="md" radius="md">
                        <Text fw={600} mb="sm">Rate Details</Text>
                        <Table striped highlightOnHover withTableBorder>
                            <Table.Thead>
                                <Table.Tr>
                                    <Table.Th>Weight ({rateInfo.weight_unit})</Table.Th>
                                    <Table.Th>Rate ({rateInfo.currency})</Table.Th>
                                </Table.Tr>
                            </Table.Thead>
                            <Table.Tbody>
                                {rateList.map((item, index) => (
                                    <Table.Tr key={index}>
                                        <Table.Td>{item.rate_per_weight}</Table.Td>
                                        <Table.Td>{item.rate?.toLocaleString()}</Table.Td>
                                    </Table.Tr>
                                ))}
                            </Table.Tbody>
                        </Table>
                    </Card>

                    {/* Close Button */}
                    <Flex justify="flex-end">
                        <Button variant="outline" onClick={onClose}>Close</Button>
                    </Flex>
                </Stack>
            )}
        </Modal>
    )
}

export default ModalDetailRate
